/**
 * A dónde lleva «Entrar».
 *
 * Con `tactil=1` cuando la pantalla es táctil: es lo único que delata un iPad,
 * que desde iPadOS 13 se presenta como Mac. El servidor lo usa sólo para decir
 * qué dispositivo pide aprobación (ADR-0026); no abre ni cierra nada.
 */
export function urlDeAcceso(): string {
  const tactil = typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1;
  return `/api/v1/auth/login?returnTo=/${tactil ? '&tactil=1' : ''}`;
}
